export default function reducer(state = {
  pending: false,
  contact: {}
}, action) {
  switch (action.type) {
    case 'START_REGISTRATION_INTERNAL': {
      return {...state, pending: true, internal: true}
    }
    case 'START_REGISTRATION_EXTERNAL': {
      return {...state, pending: true, internal: false}
    }
    case 'START_ACCOUNT_MANAGER_REGISTRATION': {
      return {...state, pending: true }
    }
    case 'SET_REGISTRATION_TOKEN': {
      return {
        ...state,
        registration_token: action.payLoad.registration_token,
        user_group: action.payLoad.user_group,
        email: action.payLoad.email
      }
    }
    case 'FINISH_REGISTRATION': {
      return {...state,
        pending: false,
        internal: undefined,
        addMore: false,
        registration_token: ''
      }
    }
    case 'ADD_MORE_REGISTRATION' : {
      return {...state, pending: true, addMore: true}
    }
    case 'NEW_CONTACT_FULFILLED': {
      return {
        ...state,
        contact: action.payLoad
      }
    }
    default:
  }

  return {...state};
}


// WEBPACK FOOTER //
// ./src/reducers/registrationReducer.js